import script from "./JoinFail.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinFail.vue?vue&type=script&setup=true&lang=ts"

import "./JoinFail.vue?vue&type=style&index=0&id=3d2f3b7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2f3b7a"]])

export default __exports__